import React, { useMemo, useState } from 'react';
import DropDown from '../../../../components/ui/dropDown';
import { enumTipoParticipante, TipoFuncionalidad } from '../../../../utils/enums';
import { useDeudor } from '../../hooks/useDeudor';
import { useCodeudor } from '../../hooks/useCodeudor';
import { SeguroDeudorEdit } from '../../models/seguroDeudorEdit';
import { SeguroCodeudorEdit } from '../../models/seguroCodeudorEdit';
import { SeguroRow } from './listaSeguros';
import { EliminarSeguroDeudor } from '../../models/seguroDeudor';
import ActionMenu, { Action } from '../../../../components/ui/materialui/actionMenu';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import ConfirmationModal from '../../../../components/ui/materialui/confirmationModal';
import { useDetalleMutuoPermissions } from '../../hooks/useDetalleMutuoPermissions';
import { useDetalleMutuoAccess } from '../../../../components/auth/DetalleMutuoPermissionGuard';

interface IProps {
    seguroRow: SeguroRow;
    setTipoSeguroSeleccionado: (value: enumTipoParticipante) => void;
    setSeguroDeudorSeleccionado: (value: SeguroDeudorEdit) => void;
    setSeguroCodeudorSeleccionado: (value: SeguroCodeudorEdit) => void;
    setShow: (value: boolean) => void;
    renderizar: () => Promise<void>;
    esVigente: boolean;
}

const seguroLabels: Record<SeguroRow["TipoSeguro"], string> = {
    CESANTIA: "cesantía",
    DESGRAVAMEN: "desgravamen"
};

const AccionesGrillaSeguros: React.FC<IProps> = (props) => {

    const { obtenerSeguroDeudor, eliminarSeguro } = useDeudor();
    const { obtenerSeguroCodeudor } = useCodeudor();
    const { hasAccess: puedeVer } = useDetalleMutuoAccess(
        props.esVigente,
        undefined,
        [TipoFuncionalidad.Bandeja_ver, TipoFuncionalidad.Cartera_ver]
    );

    // Validar si puede eliminar (Bandeja_editar)
    const { hasAccess: puedeEliminar } = useDetalleMutuoAccess(
        props.esVigente,
        TipoFuncionalidad.Bandeja_editar
    );
    const [modalConfirmacion, setModalConfirmacion] = useState({
        show: false,
        title: '',
        message: '',
        metodo: () => {
        },
    });

    async function handleEditSeguro() {
        switch (props.seguroRow.TipoParticipante) {

            case enumTipoParticipante.Deudor:
                {
                    const seguroDeudorEdit: SeguroDeudorEdit | void = await obtenerSeguroDeudor(props.seguroRow.MutuoId, props.seguroRow.SeguroId!);
                    if (!seguroDeudorEdit) return;

                    props.setSeguroDeudorSeleccionado(seguroDeudorEdit);
                    props.setTipoSeguroSeleccionado(enumTipoParticipante.Deudor);
                    props.setShow(true);
                    break;
                }

            case enumTipoParticipante.Codeudor:
                {
                    const seguroCodeudorEdit: SeguroCodeudorEdit | void = await obtenerSeguroCodeudor(props.seguroRow.MutuoId,
                        props.seguroRow.RutAsegurado!,
                        props.seguroRow.TipoSeguro);
                    if (!seguroCodeudorEdit) return;

                    props.setSeguroCodeudorSeleccionado(seguroCodeudorEdit);
                    props.setTipoSeguroSeleccionado(enumTipoParticipante.Codeudor);
                    break;
                }

            default:
                console.log("Tipo de participante desconocido");

        }

    }

    const handleDeleteSeguro = async () => {
        setModalConfirmacion({
            show: true,
            title: 'Eliminar seguro',
            message: `¿Estás seguro de eliminar el seguro ${seguroLabels[props.seguroRow.TipoSeguro]} con la póliza: ${props.seguroRow.CodigoPoliza}?`,
            metodo: () => {
                const data: EliminarSeguroDeudor = {
                    mutuoId: props.seguroRow.MutuoId,
                    seguroId: props.seguroRow.SeguroId || 0,
                    tipoSeguro: props.seguroRow.TipoSeguro
                }
                eliminarSeguro(data, props.renderizar);
            },
        });
    }

    const items = []
    if (puedeVer) {
        items.push({
            label: 'Ver seguro',
            icon: <SearchIcon />,
            onClick: handleEditSeguro,
        })
    }

    if (puedeEliminar) {
        items.push({
            label: 'Eliminar seguro',
            icon: <ClearIcon />,
            onClick: handleDeleteSeguro,
        })
    }

    return (
        <>
            {items.length > 0 && <ActionMenu actions={items} />}

            <ConfirmationModal
                onHide={() =>
                    setModalConfirmacion({
                        ...modalConfirmacion,
                        show: false,
                    })
                }
                onConfirm={modalConfirmacion.metodo}
                show={modalConfirmacion.show}
                title={modalConfirmacion.title}
                message={modalConfirmacion.message}
            />
        </>
    );
};

export default AccionesGrillaSeguros;
